import React, { Component } from "react"
import "./NavigationSidebar.scss"
import PropTypes from "prop-types"
// import {Link, IndexLink} from 'react-router'
import { Button } from "elemental"
import { Link } from "react-router"
import shop from "../../shop/shop"
import _ from "lodash"
import app from "app.controller"

export default class NavigationSidebar extends Component {
  constructor() {
    super()
    this.state = {
      categoryData: []
    }
  }

  componentDidMount() {
    shop.events.loaded.add( this.onLoad )
  }

  close = () => {
    app.sidebarLeft.close.dispatch()
  }

  onLoad = () => {
    const categoryData = _.sortBy( shop.categories, "title" )
    this.setState( {
      categoryData,
    } )
  }

  componentWillUnmount() {
    shop.events.loaded.remove( this.onLoad )
  }

  render() {
    const { categoryData } = this.state

    return (
      <nav className="nav nav-sidebar pb2">
        <h3 className="pt3">Brands</h3>
        <CategoryNavigation categories={categoryData}
                            onClose={this.close}/>
        {shop.session && <div className="">
          <h3 className="pt4">Settings</h3>
          <div className="menu-settings">
            <Link className="level-0"
                  type="link"
                  onClick={this.close}
                  to="/account"> <i className="icon icon-user"/>{translate( "nav.account" )}</Link>

            <Link className="level-0"
                  type="link"
                  onClick={this.close}
                  to="/logout">{translate( "nav.logout" )}</Link>

            <a onClick={() => {
              app.language.changed.dispatch( "en-US" )
              this.close()
            }}
               className="level-0">
              <span className="">EN</span>
            </a>
            <a onClick={() => {
              app.language.changed.dispatch( "de-DE" )
              this.close()
            }}
               className="level-0">
              <span className="">DE</span>
            </a>
          </div>
        </div>}
      </nav>
    )
  }
}

const CategoryNavigation = ( { categories, onClose } ) => {
  const addLink = function ( category, level ) {
    let children = _.map( category.children, subcat => addLink( subcat, level + 1 ) )
    let parentSegment = (category.parent) ? `/${category.parent}` : ""
    let to = `/collection${parentSegment}/${category.map_id}`
    if ( category.hide ) return null
    return (<div key={category.map_id}>
      <Link
        className={`level-${level}`}
        activeClassName="active"
        onClick={onClose}
        to={to}>{category.title}</Link>
      <div className="sub">{children}</div>
    </div>)
  }

  let cats = _.map( categories.filter( c => !c.invalid ), cat => addLink( cat, 0 ) )

  return (
    <div>
      {cats}
    </div>
  )
}

CategoryNavigation.propTypes = {
  categories: PropTypes.array
}



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationSidebar.js